const headers = {
  name: "Trial Balance",
  components: [
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
  ],
  navigate: {
    tabs: [
      {
        name: "General Ledger",
        path: "/app/common/reports",
      },
      {
        name: "Trial Balance",
        path: "",
      },
      {
        name: "Balance Sheet",
        path: "/app/common/reports/balance-sheet",
      },
      {
        name: "Profit & Loss",
        path: "/app/common/reports/profit-loss",
      },
      {
        name: "AR Report",
        path: "/app/common/reports/ar-report",
      },
      {
        name: "AP Report",
        path: "/app/common/reports/ap-report",
      },
    ],
    total: [
      { value: 0, label: "Total Debit" },
      { value: 0, label: "Total Credit" },
      { value: 0, label: "Difference" },
    ],
  },
};

export default headers;
